<script lang="ts">
  import ViewEmployerComponent from '../../components/charity/employer/ViewEmployer.svelte';
  
  export let params: { id: string };
</script>

<ViewEmployerComponent employerId={params.id} />

